module.exports = __webpack_public_path__ + "img/345.9050c72d.png";